import { clearDownloadCheckpoint, setDownloadCheckpoint, } from "../actions/downloads";
export const downloadsReducer = {
    reducers: {
        [setDownloadCheckpoint.getType()]: (state, payload) => ({
            ...state,
            checkpoints: { ...state.checkpoints, [payload.id]: payload.checkpoint },
        }),
        [clearDownloadCheckpoint.getType()]: (state, payload) => {
            const { [payload.id]: _, ...rest } = state.checkpoints;
            return { ...state, checkpoints: rest };
        },
    },
    defaults: {
        checkpoints: {},
    },
};
